// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRenewalPayrollCalendarScheduleConfigDto
 */
export interface IRenewalPayrollCalendarScheduleConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    start_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    frequency?: IRenewalPayrollCalendarScheduleConfigDtoFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    day_of_week?: IRenewalPayrollCalendarScheduleConfigDtoDayOfWeekEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    first_day_of_month?: number;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    second_day_of_month?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    month?: IRenewalPayrollCalendarScheduleConfigDtoMonthEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollCalendarScheduleConfigDto
     */
    day_of_month?: number;
}

/**
* @export
* @enum {string}
*/
export enum IRenewalPayrollCalendarScheduleConfigDtoFrequencyEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPayrollCalendarScheduleConfigDtoDayOfWeekEnum {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPayrollCalendarScheduleConfigDtoMonthEnum {
    JANUARY = 'JANUARY',
    FEBRUARY = 'FEBRUARY',
    MARCH = 'MARCH',
    APRIL = 'APRIL',
    MAY = 'MAY',
    JUNE = 'JUNE',
    JULY = 'JULY',
    AUGUST = 'AUGUST',
    SEPTEMBER = 'SEPTEMBER',
    OCTOBER = 'OCTOBER',
    NOVEMBER = 'NOVEMBER',
    DECEMBER = 'DECEMBER'
}


/**
 * Check if a given object implements the IRenewalPayrollCalendarScheduleConfigDto interface.
 */
export function instanceOfIRenewalPayrollCalendarScheduleConfigDto(value: object): value is IRenewalPayrollCalendarScheduleConfigDto {
    return true;
}

export function IRenewalPayrollCalendarScheduleConfigDtoFromJSON(json: any): IRenewalPayrollCalendarScheduleConfigDto {
    return IRenewalPayrollCalendarScheduleConfigDtoFromJSONTyped(json, false);
}

export function IRenewalPayrollCalendarScheduleConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalPayrollCalendarScheduleConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'day_of_week': json['day_of_week'] == null ? undefined : json['day_of_week'],
        'first_day_of_month': json['first_day_of_month'] == null ? undefined : json['first_day_of_month'],
        'second_day_of_month': json['second_day_of_month'] == null ? undefined : json['second_day_of_month'],
        'month': json['month'] == null ? undefined : json['month'],
        'day_of_month': json['day_of_month'] == null ? undefined : json['day_of_month'],
    };
}

export function IRenewalPayrollCalendarScheduleConfigDtoToJSON(json: any): IRenewalPayrollCalendarScheduleConfigDto {
    return IRenewalPayrollCalendarScheduleConfigDtoToJSONTyped(json, false);
}

export function IRenewalPayrollCalendarScheduleConfigDtoToJSONTyped(value?: IRenewalPayrollCalendarScheduleConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_id': value['calendar_id'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString().substring(0,10)),
        'frequency': value['frequency'],
        'day_of_week': value['day_of_week'],
        'first_day_of_month': value['first_day_of_month'],
        'second_day_of_month': value['second_day_of_month'],
        'month': value['month'],
        'day_of_month': value['day_of_month'],
    };
}

